import { VCol } from 'vuetify/lib/components/VGrid';
import { VSlider } from 'vuetify/lib/components/VSlider';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VCol,{attrs:{"cols":"2"}},[_c(VTextField,{attrs:{"label":_vm.title,"prefix":"%"},on:{"input":_vm.updateValue},model:{value:(_vm.channelPercent),callback:function ($$v) {_vm.channelPercent=$$v},expression:"channelPercent"}}),_c(VSlider,{staticStyle:{"margin-top":"-20px"},attrs:{"step":"1"},on:{"input":_vm.updateValue},model:{value:(_vm.channelPercent),callback:function ($$v) {_vm.channelPercent=$$v},expression:"channelPercent"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }